import { makeChartComp } from '../../util/makeChartComp';
var BulletChart = makeChartComp('Bullet');
export default BulletChart;
